'use strict'

/**
 * Project easy title 24
 * Created by hielo on 2019-02-22
 */

import VueProgressBar from 'vue-progressbar'

// TODO: Possibly vue-progressbar can be stylized with a css class?

const progressBatOpt = {
	color: '#ffa500',
	failedColor: 'red',
	thickness: '3px',
	transition: {
		speed: '0.2s',
		opacity: '0.6s',
		termination: 300
	},
	autoRevert: true,
	location: 'top',
	inverse: false
}

function progressBar (Vue, options) {
	Vue.use(VueProgressBar, progressBatOpt)
}

export default progressBar



// WEBPACK FOOTER //
// ./src/common/components/progressbar.js